import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Navbar from "../frontend/backend/navbar.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import axios from "axios";
import { useParams } from "react-router-dom";
import ReactPaginate from "react-paginate";
import apiConfig from '../apiConfig';

const PAGE_SIZE = 15;

const BetSummery = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [gameData, setGameData] = useState([]);
  const [totalWin, setTotalWin] = useState(0);
  const [totalBet, setTotalBet] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: "createdAt", direction: "desc" });
  const [page, setPage] = useState(0);
  const [copiedId, setCopiedId] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const params = {};
        if (startDate && endDate) {
          params.startDate = startDate;
          params.endDate = endDate;
        }
        const response = await axios.get(`${apiConfig.baseURL}/api/agent/betSummery/${id}`, { params });
        setGameData(response.data.data || []);
        setTotalWin(response.data.totalWin || 0);
        setTotalBet(response.data.totalBet || 0);
        setPage(0);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id, startDate, endDate]);

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const timeString = date.toLocaleString('en-US', {
      hour: 'numeric', minute: 'numeric', hour12: true
    }).toLowerCase();
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${timeString} ${day}.${month}.${year}`;
  };

  const sortData = (key) => {
    const direction = sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
    const sortedData = [...gameData].sort((a, b) => {
      if (key === "amount") {
        return direction === "asc" ? a.amount - b.amount : b.amount - a.amount;
      }
      return direction === "asc"
        ? new Date(a.createdAt) - new Date(b.createdAt)
        : new Date(b.createdAt) - new Date(a.createdAt);
    });
    setGameData(sortedData);
    setSortConfig({ key, direction });
    setPage(0);
  };

  const sortArrow = (key) => sortConfig.key !== key ? "" : (sortConfig.direction === "asc" ? " ▲" : " ▼");

  const copyToClipboard = (value, label) => {
    navigator.clipboard.writeText(value);
    setCopiedId(label);
    setTimeout(() => setCopiedId(null), 1200);
  };

  const CopyBtn = ({ value, label }) => (
    <button
      className="copy-btn"
      onClick={() => copyToClipboard(value, label)}
      title={value}
    >
      {copiedId === label ? "✅" : "📋"}
    </button>
  );

  const totalProfitLoss = (totalWin - totalBet).toFixed(2);
  const isProfit = totalWin - totalBet >= 0;

  const pageCount = Math.ceil(gameData.length / PAGE_SIZE);
  const pagedData = useMemo(
    () => gameData.slice(page * PAGE_SIZE, page * PAGE_SIZE + PAGE_SIZE),
    [gameData, page]
  );

  const clearFilters = () => { setStartDate(""); setEndDate(""); };

  return (
    <>
      <Navbar />
      <Chatbox />
      <HeaderRight />
      <LeftSidebar />

      <style>{`
        .bs-wrap { font-size: 13px; }
        .bs-head { display:flex; justify-content:space-between; align-items:center; flex-wrap:wrap; gap:8px; margin-bottom:10px; }
        .bs-head h4 { margin:0; font-weight:600; }
        .bs-filters { display:flex; gap:8px; flex-wrap:wrap; align-items:flex-end; margin-bottom:10px; padding:8px; background:#f7f8fa; border-radius:6px; }
        .bs-filters label { font-size:11px; color:#888; display:block; margin-bottom:2px; }
        .bs-filters input { font-size:12px; padding:4px 6px; height:30px; }
        .bs-cards { display:grid; grid-template-columns:repeat(3,1fr); gap:8px; margin-bottom:10px; }
        .bs-card { padding:8px 10px; border-radius:6px; color:#fff; }
        .bs-card .lbl { font-size:10px; opacity:.85; }
        .bs-card .val { font-size:16px; font-weight:700; }
        .badge-sm { font-size:10px; padding:2px 6px; border-radius:4px; color:#fff; }
        .copy-btn { border:1px solid #ddd; background:#fff; border-radius:4px; font-size:10px; padding:1px 5px; cursor:pointer; margin-left:4px; }
        .id-chip { font-family:monospace; font-size:11px; color:#555; }

        /* Desktop table */
        .bs-table { display:none; }
        .bs-table th { cursor:pointer; font-size:12px; white-space:nowrap; }
        .bs-table td { font-size:12px; vertical-align:middle; }

        /* Mobile cards */
        .bs-rows { display:block; }
        .bs-row-card { border:1px solid #eee; border-radius:6px; padding:8px 10px; margin-bottom:6px; background:#fff; }
        .bs-row-top { display:flex; justify-content:space-between; align-items:center; margin-bottom:4px; }
        .bs-row-amt { font-weight:700; }
        .bs-row-meta { display:flex; flex-wrap:wrap; gap:4px 10px; font-size:11px; color:#777; }
        .bs-row-ids { margin-top:4px; display:flex; flex-direction:column; gap:2px; }

        @media (min-width: 768px) {
          .bs-cards { grid-template-columns:repeat(3,1fr); }
          .bs-table { display:table; width:100%; }
          .bs-rows { display:none; }
        }
      `}</style>

      <div className="content-body">
        <div className="container-fluid">
          <div className="card col-lg-12">
            <div className="card-body bs-wrap">

              <div className="d-flex gap-2">
                <Link to={`bet-summery/${id}`} className="btn btn-outline-secondary btn-sm active">
                  Bet Summary
                </Link> 
                <Link to={`/exchange-summery/${id}`} className="btn btn-outline-secondary btn-sm">
                  Lucky History
                </Link> 
                <Link to={`/ninewicket-summery/${id}`} className="btn btn-outline-secondary btn-sm">
                  NineWicket History
                </Link>
              </div>

              <div className="bs-filters">
                <div>
                  <label>Start Date</label>
                  <input type="date" className="form-control form-control-sm" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                </div>
                <div>
                  <label>End Date</label>
                  <input type="date" className="form-control form-control-sm" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                </div>
                {(startDate || endDate) && (
                  <button className="btn btn-outline-secondary btn-sm" onClick={clearFilters}>Clear</button>
                )}
              </div>

              <div className="bs-cards">
                <div className="bs-card" style={{ background: isProfit ? "#1b9e5a" : "#d9455f" }}>
                  <div className="lbl">P/L</div>
                  <div className="val">{totalProfitLoss}</div>
                </div>
                <div className="bs-card" style={{ background: "#2b8aef" }}>
                  <div className="lbl">Wins</div>
                  <div className="val">{totalWin.toFixed(2)}</div>
                </div>
                <div className="bs-card" style={{ background: "#6c5ce7" }}>
                  <div className="lbl">Bets</div>
                  <div className="val">{totalBet.toFixed(2)}</div>
                </div>
              </div>

              {loading ? (
                <div className="text-center py-4">
                  <div className="spinner-border spinner-border-sm text-primary" role="status" />
                  <div className="text-muted mt-2" style={{ fontSize: 12 }}>Loading...</div>
                </div>
              ) : pagedData.length === 0 ? (
                <div className="text-center text-muted py-4">No data found</div>
              ) : (
                <>
                  {/* Desktop table */}
                  <div className="table-responsive">
                    <table className="table table-bordered table-hover bs-table">
                      <thead className="table-light">
                        <tr>
                          <th onClick={() => sortData("createdAt")}>Date{sortArrow("createdAt")}</th>
                          <th onClick={() => sortData("amount")}>Amount{sortArrow("amount")}</th>
                          <th>Type</th>
                          <th>Game</th>
                          <th>Player</th>
                          <th>Session</th>
                          <th>Round</th>
                          <th>Txn</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pagedData.map((item, i) => (
                          <tr key={item.transaction_id || i}>
                            <td className="text-nowrap">{formatDate(item.createdAt)}</td>
                            <td className={item.amount >= 0 ? "text-success fw-bold" : "text-danger fw-bold"}>
                              {item.amount.toFixed(2)}
                            </td>
                            <td>
                              <span className="badge-sm" style={{ background: String(item.type).toLowerCase().includes("win") ? "#1b9e5a" : "#888" }}>
                                {item.type}
                              </span>
                            </td>
                            <td>{item.gameName}</td>
                            <td className="id-chip">{item.player_id.substring(0, 6)}...<CopyBtn value={item.player_id} label={`p-${i}`} /></td>
                            <td className="id-chip">{item.session_id.substring(0, 6)}...<CopyBtn value={item.session_id} label={`s-${i}`} /></td>
                            <td className="id-chip">{item.round_id.substring(0, 6)}...<CopyBtn value={item.round_id} label={`r-${i}`} /></td>
                            <td className="id-chip">{item.transaction_id.substring(0, 6)}...<CopyBtn value={item.transaction_id} label={`t-${i}`} /></td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Mobile cards */}
                  <div className="bs-rows">
                    {pagedData.map((item, i) => (
                      <div className="bs-row-card" key={item.transaction_id || i}>
                        <div className="bs-row-top">
                          <span>{formatDate(item.createdAt)}</span>
                          <span className={"bs-row-amt " + (item.amount >= 0 ? "text-success" : "text-danger")}>
                            {item.amount.toFixed(2)}
                          </span>
                        </div>
                        <div className="bs-row-meta">
                          <span className="badge-sm" style={{ background: String(item.type).toLowerCase().includes("win") ? "#1b9e5a" : "#888" }}>
                            {item.type}
                          </span>
                          <span>{item.gameName}</span>
                        </div>
                        <div className="bs-row-ids">
                          <div className="id-chip">Player: {item.player_id.substring(0, 10)}...<CopyBtn value={item.player_id} label={`p-${i}`} /></div>
                          <div className="id-chip">Session: {item.session_id.substring(0, 10)}...<CopyBtn value={item.session_id} label={`s-${i}`} /></div>
                          <div className="id-chip">Round: {item.round_id.substring(0, 10)}...<CopyBtn value={item.round_id} label={`r-${i}`} /></div>
                          <div className="id-chip">Txn: {item.transaction_id.substring(0, 10)}...<CopyBtn value={item.transaction_id} label={`t-${i}`} /></div>
                        </div>
                      </div>
                    ))}
                  </div>

                  {pageCount > 1 && (
                    <ReactPaginate
                      previousLabel="←"
                      nextLabel="→"
                      pageCount={pageCount}
                      forcePage={page}
                      onPageChange={(e) => setPage(e.selected)}
                      containerClassName="pagination justify-content-center mt-3"
                      pageClassName="page-item"
                      pageLinkClassName="page-link"
                      previousClassName="page-item"
                      previousLinkClassName="page-link"
                      nextClassName="page-item"
                      nextLinkClassName="page-link"
                      activeClassName="active"
                      breakClassName="page-item"
                      breakLinkClassName="page-link"
                    />
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BetSummery;